var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 17.4999H12.5V15.8333H14.1667V17.4999ZM17.5 7.49992H15.8333V5.83325H17.5V7.49992ZM2.5 15.8333V4.16659C2.5 3.24992 3.25 2.49992 4.16667 2.49992H7.5V4.16659H4.16667V15.8333H7.5V17.4999H4.16667C3.25 17.4999 2.5 16.7499 2.5 15.8333ZM15.8333 4.16659V2.49992C16.75 2.49992 17.5 3.24992 17.5 4.16659H15.8333ZM10.8333 19.1666H9.16667V0.833252H10.8333V19.1666ZM17.5 14.1666H15.8333V12.4999H17.5V14.1666ZM14.1667 4.16659H12.5V2.49992H14.1667V4.16659ZM17.5 10.8333H15.8333V9.16658H17.5V10.8333ZM17.5 15.8333C17.5 16.7499 16.75 17.4999 15.8333 17.4999V15.8333H17.5Z",
    fill: "#3A4861"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/Inactive.5e28806b669d33ebda1a735e5a277992.svg";
export { ForwardRef as ReactComponent };